<app-main-layout>
  <router-outlet #o="outlet"></router-outlet>
</app-main-layout>